import { render } from "./CampaignsPage.vue?vue&type=template&id=725d458a&lang=html"
import script from "./CampaignsPage.vue?vue&type=script&lang=js"
export * from "./CampaignsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__